import { render, staticRenderFns } from "./ModalMotivoAlteracao.vue?vue&type=template&id=6cf3796a&scoped=true"
import script from "./ModalMotivoAlteracao.vue?vue&type=script&lang=js"
export * from "./ModalMotivoAlteracao.vue?vue&type=script&lang=js"
import style0 from "./ModalMotivoAlteracao.vue?vue&type=style&index=0&id=6cf3796a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf3796a",
  null
  
)

export default component.exports